module.exports = __webpack_public_path__ + "static/lascaux_devanture_bw-b42a19eb680854e040ee64717627c9e8.jpg";